// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// eslint-disable-next-line no-unused-vars
// import App from './App';
import 'antd/dist/antd.css';
// import reportWebVitals from './reportWebVitals';
// import store from './store/index';
import { HashRouter } from 'react-router-dom';
import Router from './router';
import './index.less';
import { getQueryParam, setLocalStorage } from 'mazey';
import { metroLog } from './utils/utils';

// 初始化
(() => {
    metroLog.log('页面初始化中');
    const AdminToken = getQueryParam('Admin-Token');
    const AdminExpiresIn = getQueryParam('Admin-Expires-In');
    if (AdminToken && AdminExpiresIn) {
        metroLog.log('AdminToken', AdminToken);
        metroLog.log('AdminExpiresIn', AdminExpiresIn);
        setLocalStorage('AdminToken', AdminToken);
        setLocalStorage('AdminExpiresIn', AdminExpiresIn);
    }
})();

ReactDOM.render(
    // <Provider store={store}>
    // <React.StrictMode>
    <HashRouter>
        <Router />
    </HashRouter>,
    // </React.StrictMode>,
    // </Provider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
